import { createAction } from "@reduxjs/toolkit";

import {
  CANCEL_BACKGROUND_UPLOAD_TASK,
  COMPLETE_BACKGROUND_UPLOAD_TASK,
  INVALIDATE_BACKGROUND_UPLOAD_TASK,
  START_BACKGROUND_UPLOAD_TASK,
} from "./actionTypes";

import { BackgroundUploadTaskRequest } from "src/types/backgroundTask";
import _ from "lodash";
import { put, select, takeEvery } from "redux-saga/effects";
import { addAssetsToCollectionOnServer, addAssetsToSectionOnServer, addAssetToCollection } from "./collections";
import { CollectionAsset } from "src/types/collections";
import { addAssetToStream } from "./streams";
import { addAssetToGroup } from "./groups";
import { addAssetsToConversationOnServer, addAssetsToConversationSectionOnServer, addAssetToConversation } from "./conversation";
import { addAssetsToCollection } from "src/legacy/redux/actions/editCollection";
import { addAssetToDealRoom } from "./dealRoom";
import { DealRoomAsset } from "src/types/dealRoom";

export const startBackgroundUploadTask = createAction<BackgroundUploadTaskRequest>(START_BACKGROUND_UPLOAD_TASK);
export const completeBackgroundUploadTask = createAction<string>(COMPLETE_BACKGROUND_UPLOAD_TASK);
export const cancelBackgroundUploadTask = createAction<string>(CANCEL_BACKGROUND_UPLOAD_TASK);
export const invalidateBackgroundUploadTask = createAction<string>(INVALIDATE_BACKGROUND_UPLOAD_TASK);

const completeBackgroundUploadTaskSaga = function* (action: ReturnType<typeof completeBackgroundUploadTask>): any {
  const id = action.payload;

  const task = yield select((state: any) => {
    const tasks = _.get(state, `backgroundTasks.tasks`);
    return _.find(tasks, { id });
  });

  const assets = yield select((state: any) => {
    return _.get(task, "assets", []).map((asset: any) => {

      const entityType = _.get(asset, "entityType");
      if (entityType === "asset-upload") {

        const id = _.get(asset, "id");

        const uploadState = _.get(state, 'asset.upload');
        const items = _.keys(uploadState).map(key => {
          const upload = _.get(uploadState, `[${key}]`);
          return upload;
        });

        const upload = _.find(items, { id });
        if (upload && upload.created) {
          return upload.item;
        }
      }

      return asset;
    });
  });

  if(_.isEmpty(assets)){
    return;
  }
  if(task.entity.entityType === "deal_room"){
    const dealRoom = task.entity.id;
    const section = task.entity.section;
      yield put(addAssetToDealRoom({
        dealRoom: dealRoom,
        section: section ? parseInt(section) : undefined,
        assets: assets.map(item => ({ id: item.id, asset: item } as DealRoomAsset)),
        addAt: "end"
      }));
  } else if(task.entity.entityType === "collection"){
    const collection = task.entity.id;
    const section = task.entity.section;

    const editing = yield select((state: any) => {  
      const editCollection = _.get(state, `collections.edit`);
      return editCollection && editCollection.id === collection;
    });

    if(editing){
      yield put(addAssetToCollection({
        collection: collection,
        section: section ? parseInt(section) : undefined,
        assets: assets.map(item => ({ id: item.id, asset: item } as CollectionAsset)),
        addAt: "end"
      }));

    }else {
      if(section === undefined){
        yield put(addAssetsToCollectionOnServer({
          collection: collection,
          assets: assets.map(item => ({ id: item.id, asset: item } as CollectionAsset)),
          addAt: "end"
        }));
      }else {
        yield put(addAssetsToSectionOnServer({
          collection: collection,
          section: section,
          assets: assets.map(item => ({ id: item.id, asset: item } as CollectionAsset)),
          addAt: "end"
        }));
      }
    }
  } else if(task.entity.entityType === "stream"){
    const stream = task.entity.id;
    yield put(addAssetToStream({
      streamId: stream,
      assets: assets.map(item => item.id),
    }));
  } else if(task.entity.entityType === "group"){
    const group = task.entity.id;
    yield put(addAssetToGroup({
      groupId: group,
      assets: assets.map(item => item.id),
    }));
  } else if(task.entity.entityType === "share"){
    const conversation = task.entity.id;
    const section = task.entity.section;

    const editing = yield select((state: any) => {  
      const editConversation = _.get(state, `conversations.edit`);
      return editConversation && editConversation.id === conversation;
    });

    if(editing){
      yield put(addAssetToConversation({
        conversation: conversation,
        section: section ? parseInt(section) : undefined,
        assets: assets.map(item => ({ id: item.id, asset: item } as CollectionAsset)),
        addAt: "end"
      }));
    }else {
      if(section === undefined){
        yield put(addAssetsToConversationOnServer({
          conversation: conversation,
          assets: assets.map(item => ({ id: item.id, asset: item } as CollectionAsset)),
          addAt: "end"
        }));
      }else {
        yield put(addAssetsToConversationSectionOnServer({
          conversation: conversation,
          section: section,
          assets: assets.map(item => ({ id: item.id, asset: item } as CollectionAsset)),
          addAt: "end"
        }));
      }
    }
  }
};

export default function* backgroundTaskSaga() {
  yield takeEvery(COMPLETE_BACKGROUND_UPLOAD_TASK, completeBackgroundUploadTaskSaga);
}